import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatCard, MatCardContent } from '@angular/material/card';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { type AbstractControl, type FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatDivider } from '@angular/material/divider';
import { TranslocoDirective, TranslocoPipe } from '@jsverse/transloco';
import { ProgressBarComponent } from '@pct-ng/common/component';
import { AbstractFormFragmentComponent } from './abstract-form-fragment.component';
import { PreventClickDirective } from '../../directive/prevent-click.directive';
import { PreventKeyDownDirective } from '../../directive/prevent-key-down.directive';
import { ControlErrorComponent } from '@pct-ng/form';
import { CustomMatSvgIconDirective } from '@pct-ng/icon';
import { MatFormField, MatInput, MatLabel, MatSuffix } from '@angular/material/input';
import {
  NgxMatDatepickerInput,
  NgxMatDatepickerToggle,
  NgxMatDatetimepicker,
} from '@ngxmc/datetime-picker';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';

interface FormType {
  publishedFrom: FormControl<Date | null>;
  publishedTo: FormControl<Date | null>;
  isPublishNotificationEnabled: FormControl<boolean>;
  [key: string]: AbstractControl<any, any>;
}

@Component({
  selector: 'cappus-news-details-dates-form-fragment',
  imports: [
    MatCard,
    MatDivider,
    MatCardContent,
    MatSlideToggle,
    ReactiveFormsModule,
    TranslocoDirective,
    ProgressBarComponent,
    ControlErrorComponent,
    CustomMatSvgIconDirective,
    MatFormField,
    MatIcon,
    MatInput,
    MatLabel,
    MatSuffix,
    NgxMatDatepickerInput,
    NgxMatDatepickerToggle,
    NgxMatDatetimepicker,
    MatFormField,
    MatIconButton,
    TranslocoPipe,
    PreventClickDirective,
    PreventKeyDownDirective,
  ],
  templateUrl: './news-details-dates-form-fragment.component.html',
  host: {
    class: 'block w-full',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewsDetailsDatesFormFragmentComponent<
  FORM extends FormType = FormType,
> extends AbstractFormFragmentComponent<FORM> {}
